import { Dialog } from "primereact/dialog";

export default function PPConstraintViolationModal({ visible, onClose, violations }) {

     const blocking = violations || [];

     return (
          <Dialog
               header="Regel kann nicht gespeichert werden"
               visible={visible}
               style={{ width: "40vw" }}
               onHide={onClose}
               footer={
                    <button className="btn btn-primary btn-lg m-2" onClick={onClose}>
                         OK
                    </button>
               }
          >
               {blocking.length === 0 ? (
                    <p className="m-0">
                         Es liegen keine detaillierten Hinweise vor, die Regel kann jedoch aktuell nicht gespeichert werden.
                    </p>
               ) : (
                    <div>
                         <p className="mb-2">
                              Bitte korrigieren Sie die folgenden Punkte, bevor die Regel gespeichert werden kann:
                         </p>
                         <ul className="mb-0">
                              {blocking.map((violation) => (
                                   <li key={violation.id}>
                                        {violation.message}
                                   </li>
                              ))}
                         </ul>
                    </div>
               )}
          </Dialog>
     );
}

